import {
  AddProductPage,
  ApplicationDetailsPage,
  ApplicationFormPage,
  ApplicationsPageWrapper,
  CalculatorPage,
  DashboardPage,
  EditProductPage,
  HomePage,
  LoginPage,
  NotFoundPage,
  ProductsPage,
  UsersPage,
} from 'pages';
import { BtlApplicationFormPage } from '../pages/BtlApplicationFormPage/BtlApplicationFormPage';
import { IRouteProps } from './types';
import { PageURL } from './pageURL';
import { ApplicationFormLayout, MainLayout } from 'layouts';
import { PermissionType } from 'enums/permissionType.enum';
import { SignupPage } from '../pages';

export const routes: IRouteProps[] = [
  {
    authRoles: [],
    path: PageURL.LOGIN,
    component: LoginPage,
  },
  {
    authRoles: [],
    path: PageURL.SIGNUP,
    component: SignupPage,
  },
  {
    authRoles: [],
    path: PageURL.NOT_FOUND,
    component: NotFoundPage,
  },
  {
    authRoles: [],
    path: PageURL.CALCULATOR,
    component: CalculatorPage,
  },
  {
    authRoles: [PermissionType.ADMIN, PermissionType.UNDERWRITER, PermissionType.ANALYST, PermissionType.FINANCE],
    path: PageURL.PRODUCTS,
    component: ProductsPage,
    layout: MainLayout,
  },
  {
    authRoles: [PermissionType.ADMIN, PermissionType.UNDERWRITER, PermissionType.FINANCE],
    path: PageURL.PRODUCTS_NEW,
    component: AddProductPage,
    layout: MainLayout,
  },
  {
    authRoles: [PermissionType.ADMIN, PermissionType.UNDERWRITER, PermissionType.FINANCE],
    path: PageURL.PRODUCTS_EDIT,
    component: EditProductPage,
    layout: MainLayout,
  },
  {
    authRoles: [PermissionType.ADMIN, PermissionType.UNDERWRITER],
    path: PageURL.USERS,
    component: UsersPage,
    layout: MainLayout,
  },
  {
    authRoles: [PermissionType.ADMIN, PermissionType.BROKER, PermissionType.BROKER_SALES, PermissionType.ANALYST],
    path: PageURL.APPLICATIONS,
    component: ApplicationsPageWrapper,
    layout: MainLayout,
  },
  {
    authRoles: [PermissionType.ADMIN, PermissionType.BROKER, PermissionType.BROKER_SALES],
    path: PageURL.APPLICATION_DETAILS,
    component: ApplicationDetailsPage,
    layout: MainLayout,
  },
  {
    authRoles: [PermissionType.ADMIN, PermissionType.BROKER, PermissionType.BROKER_SALES],
    path: PageURL.APPLICATION_EDIT,
    component: ApplicationFormPage,
    layout: ApplicationFormLayout,
  },
  {
    authRoles: [
      PermissionType.ADMIN,
      PermissionType.BROKER,
      PermissionType.BROKER_SALES,
      PermissionType.UNDERWRITER,
      PermissionType.ANALYST,
      PermissionType.FINANCE,
    ],
    path: PageURL.ROOT,
    component: HomePage,
    layout: MainLayout,
  },
  {
    authRoles: [PermissionType.ADMIN, PermissionType.UNDERWRITER],
    path: PageURL.DASHBOARD,
    component: DashboardPage,
    layout: MainLayout,
  },
  {
    authRoles: [PermissionType.ADMIN, PermissionType.BROKER, PermissionType.BROKER_SALES],
    path: PageURL.BTL_APPLICATION_EDIT,
    component: BtlApplicationFormPage,
    layout: ApplicationFormLayout,
  },
  {
    authRoles: [PermissionType.ADMIN, PermissionType.BROKER, PermissionType.BROKER_SALES],
    path: PageURL.BTL_APPLICATION_CREATE,
    component: BtlApplicationFormPage,
    layout: ApplicationFormLayout,
  },
];
